<template>
	<div class="header">
		<div class="header_con">
			<div class="header_logo">
				<img src="../../assets/image/20241216_1826_dbLogo.png" alt="" />
				<!-- <span>豆包知道</span> -->
			</div>
			<ul class="header_tabs">
				<li v-for="(item, index) in tabsList" :key="index" @click="goRoute(item)">
					<el-tooltip class="item" effect="dark" :content="item.label" placement="top"
						:popper-class="classNames(item)">
						<span v-html="item.icon" class="iconfont" :style="styles(item)"></span>
					</el-tooltip>
					<span style="font-size: 11px;" :style="styles(item)">{{item.label}}</span>
				</li>
			</ul>
			<div class="header_right">
				<div v-if="messageKey">
				<el-popover v-model="popoverKey" placement="bottom" title="" width="500" trigger="click">
					<message-header @closeMask="popoverKey=false" @input="tabclick"
						:messageNum='stateMessageUnreadyNumber' :data="messageTabsList" v-model="tabs"></message-header>
					<div style="margin-right: 40px;" class="notice-message" slot="reference">
						<el-badge :hidden="stateMessageUnreadyNumber.platform<=0" :value="stateMessageUnreadyNumber.platform" slot="label" :max="99"
							class="message-header-wrap-badge">
							<i style="font-size: 25px;line-height: 40px;" class="el-icon-bell"></i>
						</el-badge>
					</div>
				</el-popover>
				</div>
				<img :src="avatar_url" alt="" class="header_user_img" />
				<el-dropdown trigger="click" @command="exit">
					<span class="el-dropdown-link">
						{{name}}<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown" class="header_exit_login">
						<el-dropdown-item icon="el-icon-switch-button">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import {
		resetRouter
	} from '../../router.js'
	import messageHeader from '../message/messageHeader.vue'
	import messageMixin from '@/components/mixin/messageMixin.js'
	export default {
		name: 'Headers',
		components: {
			'message-header': messageHeader
		},
		mixins: [messageMixin],
		data() {
			return {
				name: localStorage.getItem('name') || '',
				avatar_url: localStorage.getItem('avatar_url') || '',
				tabsList: [{
						icon: '&#xe66e;',
						icon_active: '#170B1A',
						value: '/',
						isFlag: '/',
						label: '抖音',
						word: 'douyin_header'
					},
					{
						icon: '&#xe630;',
						icon_active: '#004ff9',
						value: '/dd/',
						isFlag: '/dd/',
						label: '抖店',
						word: 'doudian_header'
					},
					{
						icon: '&#xe8dc;',
						icon_active: '#FF8718',
						value: '/ks/',
						isFlag: '/ks/',
						label: '快手',
						word: 'kuaishou_header'
					},
					{
						icon: '&#xe60c;',
						icon_active: 'rgb(40,196,69)',
						value: '/wx/',
						isFlag: '/wx/',
						label: '微信',
						word: 'wx_header'
					},
					{
						icon: '&#xea52;',
						icon_active: '#ff8328',
						value: '/sph/',
						isFlag: '/sph/',
						label: '视频号',
						word: 'sph_header'
					},
					{
						icon: '&#xe957;',
						icon_active: '#ff2139',
						value: '/xhs/',
						isFlag: '/xhs/',
						label: '小红书',
						word: 'xhs_header'
					}
				],
				tabs: 'platform',
				messageTabsList: [
					{
						label: '全部消息',
						value: 'total',
						name: 'first',
						num: 0,
						index: 0,
						hidden: true
					},
					{
						label: '平台公告',
						value: 'platform',
						name: 'second',
						num: 100,
						index: 1
					},
					{
						label: '审核通知',
						value: 'audit',
						name: 'third',
						num: 518,
						index: 2,
						hidden: true
					}
				],
				activeTab: 0,
				messageNum: '',
				popoverKey: false,
				messageKey:false,

				path: 'ws://dbzd-ws.fat.doutuimao.net/', //建立的连接
				timeoutObj: undefined,
				serverTimeoutObj: undefined,
				socket: undefined,
				lockReconnect: false // 为true时，是心跳重连的websocket断开连接
			}
		},
		created() {
			this.handleAgreement()
			this.messageNumFun()

			// this.init()
			this.menuTreeList.forEach(item=>{
				if(item.children?.length>0){
					item.children.forEach(ite=>{
						if(ite.route_name== this.staticPath + 'message'){
							this.messageKey=true
						}
					})
				}
				
			})
		},

		mounted() {
			//初始化

		},
		methods: {
			...mapMutations('permission', ['getMenuTreeList']),
			...mapMutations('message', ['mutationsMessageUnreadyNumber', 'changeWaitCount']),
			...mapActions('message', ['messageUnreadyNumber']),
			async messageNumFun() {
				let res = await this.messageUnreadyNumber()
				this.mutationsMessageUnreadyNumber(res)
				
			},


			tabclick(index) {
				this.activeTab = index
			},



			init(row) {
				this.connectSocket() // 建立websocket连接
				this.socket.onopen = (e) => {
					console.log('Connection to server opened');
					// 连接成功执行的逻辑
				}
				// websocket连接接收消息后监听事件
				this.socket.onmessage = async (msg) => {
					try {
						var data = JSON.parse(msg.data)
						console.log(data)
					} catch (err) {
						return
					}
					// websocket连接接收消息处理逻辑
				}
			},
			// 连接websocket
			connectSocket() {
				var url = 'ws://dbzd-ws.fat.doutuimao.net/'
				this.socket = this.createWebSocket(url)
				// 监听连接失败
				this.socket.onerror = this.websocketonerror
				// 监听连接关闭
				this.socket.onclose = this.websocketclose
			},

			websocketonerror() { // 监听连接失败
				console.log('websocket连接断开')
				this.connectSocket()
			},
			websocketclose(e) { // 监听连接
				console.log('断开连接', e)
				this.connectSocket() // websocket关闭链接重连
			},

			// 创建websocket对象
			createWebSocket(url) {
				console.log(url)
				try {
					if (window.WebSocket)
						return new WebSocket(url);
					if (window.MozWebSocket)
						return new MozWebSocket(url);
				} catch (e) {}
				return false;
			},

			init(row) {
				this.connectSocket()
				this.socket.onopen = (e) => {
					console.log('Connection to server opened');
					this.longstart(); // 成功建立连接后，创建心跳检测
					// 连接成功执行的逻辑
				}
				this.socket.onmessage = async (e) => {
					console.log('心跳重置')
					this.longstart();
					try {
						console.log("==websocket接收数据==");
						if (!e.data || e.data == "链接成功") {
							return;
						}
						console.log(666, e);
						let res = JSON.parse(e.data);
						console.log(7777, res);

						let messageNum = JSON.parse(JSON.stringify(this.stateMessageUnreadyNumber))

						if (res.data.mtype == 1) {
							messageNum.total++
							messageNum.platform++

						} else if (res.data.mtype == 2) {
							messageNum.total++
							messageNum.audit++
						}
						this.mutationsMessageUnreadyNumber(messageNum)
					} catch (err) {
						return
					}
					// websocket连接接收消息处理
				}
			},
			longstart() {
				clearInterval(this.timeoutObj)
				clearTimeout(this.serverTimeoutObj);
				// clearInterval(this.overTime)
				this.timeoutObj = setInterval(() => {
					let data = { //向端发送协议 初始化
						type: 'init',
						uid: localStorage.getItem('id'),
					}
					console.log('重置监测心跳',data)
					this.socket.send(JSON.stringify(data))
					this.serverTimeoutObj = setTimeout(() => {
						this.lockReconnect = true // 心跳重连设置为true
						console.log("后台挂掉，没有心跳了....");
						console.log("打印websocket的地址:" + this.socket);
						this.socket.close();
						// createWebSocket();
					}, 2000);
				}, 30000)
				// },110000)
			},
			websocketclose(e) { // 关闭
				console.log('断开连接', e)
				//lockReconnect为true在进行重连
				if (this.lockReconnect) {
					this.connectSocket()
				} else {}
			},





			exit() {
				if (localStorage.getItem('token')) {
					this.$router.replace(this.staticPath + 'login')
					if (this.cancelRouteFlag) {
						return
					}
					this.removeStroage()
					this.getMenuTreeList([])
					this.$router.replace(this.staticPath + 'login')
					this.changeWaitCount({})
					resetRouter()
				}
			},
			removeStroage() {
				localStorage.removeItem('token')
				localStorage.removeItem('name')
				localStorage.removeItem('avatar_url')
				localStorage.removeItem('breadCrumbList')
				localStorage.removeItem('institution')
				localStorage.removeItem('platPath')
				localStorage.removeItem('wattingTime')
				localStorage.removeItem('desc')
			},
			goRoute(item) {
				localStorage.setItem('platPath',item.value)
				localStorage.removeItem('breadCrumbList')
				window.location.href = location.origin + item.value
			}
		},
		computed: {
			...mapState(['cancelRouteFlag']),
			...mapState('message', ['stateMessageUnreadyNumber']),
			...mapState("permission", ["menuTreeList"]),
			styles() {
				return (item) => {
					return {
						'color': this.staticPath === item.isFlag ? item.icon_active : ''
					}
				}
			},
			classNames() {
				return (item) => {
					return this.staticPath === item.isFlag ? `default_header ${item.word}` : 'default_header'
				}
			},
			
		},
		watch: {
			cancelRouteFlag(news) {
				if (news == 'login') {
					this.getMenuTreeList([])
					this.removeStroage()
					resetRouter()
				}
			},

			stateMessageUnreadyNumber() {
				this.popoverKey = false
			}
			
		}
	}
</script>
<style lang="less">
	.header_exit_login {
		.el-dropdown-menu__item {
			color: #EC4561;
		}
	}

	.el-tooltip__popper {
		&.default_header {
			background: #170B1A;
			border: 1px solid #170B1A;
		}

		&.kuaishou_header {
			background: #FF8718;
			border: 1px solid #FF8718;
		}
	}

	.kuaishou_header[x-placement^=bottom] .popper__arrow {
		border-bottom-color: #FF8718 !important;
	}

	.kuaishou_header[x-placement^=bottom] .popper__arrow:after {
		border-bottom-color: #FF8718 !important;
	}

	.douyin_header[x-placement^=bottom] .popper__arrow {
		border-bottom-color: #170B1A !important;
	}

	.douyin_header[x-placement^=bottom] .popper__arrow:after {
		border-bottom-color: #170B1A !important;
	}

	.notice-message {
		.message-header-wrap-badge {
			.el-badge__content {
				&.is-fixed {
					top: 10px;
					right: 13px;
				}
			}
		}
	}
</style>
<style lang="less" scoped>
	.header {
		height: 80px;
		background-color: #fff;
		padding-right: 40px;
		box-sizing: border-box;
		box-shadow: 0px 8px 24px 0px rgba(18, 38, 63, 0.1);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
		width: 100%;
		.header_con {
			min-width: 1270px;
			max-width: 1270px;
			height: 100%;
			margin: 0 auto;
			display: flex;
			align-items: center;
		}

		.header_logo {
			width: 120px;
			background: #FFF;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			margin-left: 22px;
			margin-right: 92px;
			img {
				// margin-right: 8px;
				width: 100%;
				// border-radius: 100%;
			}

			span {
				font-size: 20px;
				color: #333;
			}
		}

		.header_right {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: flex-end;

			.header_user_img {
				margin-right: 5px;
				width: 32px;
				height: 32px;
				border-radius: 100%;
				overflow: hidden;
				// position: relative;
				// top: 2px;
			}
		}

		.header_tabs {
			display: flex;
			align-items: center;
			margin-left: 20px;

			li {
				list-style: none;
				display: flex;
				flex-direction: column;
				align-items: center;

				&:not(:first-child) {
					margin-left: 48px;
				}

				span {
					cursor: pointer;
					color: #ccc;

					&.iconfont {
						font-size: 38px;
					}
				}
			}
		}
	}
</style>
